
@if (addDevice) {
  <div class="AddEndpoints">
    <div class="AddEndpointsHead p-0">
      <h4 class="m-0 mt-3 ml-4">
        <span (click)="enableAddDevice = 'addDevice'" [ngClass]="(enableAddDevice == 'addDevice') ? 'text-yellow border-bottom border-yellow link-cursor' : 'link-cursor' ">
          {{ 'Add Device' | translate }}
        </span>
        <span (click)="enableAddDevice = 'orderNewDevice'" [ngClass]="(enableAddDevice == 'orderNewDevice') ? 'text-yellow border-bottom border-yellow link-cursor pl-2' : 'link-cursor pl-2' ">
          {{ 'Order New Device' | translate }}
        </span>
      </h4>
      <div class="EndpointClose" (click)="addDevices()">
        <svg width="27" height="27" viewBox="0 0 27 27" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fill-rule="evenodd">
            <path d="M0 0h27v27H0z" />
            <path d="M0 0h24v24H0z" />
            <path [attr.fill]="colors.black" fill-rule="nonzero"
              d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </g>
          </svg>
        </div>
      </div>
      <div class="AddEndPointBody">
        @if (enableAddDevice == 'addDevice') {
          <h6 class="heading-class">Add Device- dolor sit amet, consectetur adipiscing elit eiusmod incididunt.</h6>
        }
        @if (enableAddDevice == 'orderNewDevice') {
          <h6 class="heading-class">Order New Device- dolor sit amet, consectetur adipiscing elit eiusmod incididunt.</h6>
        }
        <form class="EndpointForm" method="post">
          @if (enableAddDevice == 'addDevice') {
            <div class="BoilerRoom">
              <div class="persondropdown">
                <select class="custom-dropdown">
                  <option [selected]="true" [ngValue]="'0'" [defaultSelected]="true">{{ 'Device ID' | translate }}</option>
                </select>
              </div>
              <div class="group-select">
                <select class="custom-dropdown">
                  <option selected>{{ 'Parameter Type' | translate }}</option>
                </select>
                <select class="custom-dropdown">
                  <option selected>{{ 'Assign Site / Department' | translate }}</option>
                </select>
              </div>
              <div class="createButton mt-4">
                <button (click)="addNewDevice()" class="btn btn-primary">{{ 'Add Device' | translate }}</button>
              </div>
            </div>
          }
          @if (enableAddDevice == 'orderNewDevice') {
            <div class="BoilerRoom">
              <div class="group-select">
                <select class="custom-dropdown">
                  <option selected>{{ 'Device Type' | translate }}</option>
                </select>
                <select class="custom-dropdown">
                  <option selected>{{ 'Parameter Type' | translate }}</option>
                </select>
              </div>
              <div class="createButton mt-4">
                <button (click)="addNewDevice()" class="btn btn-primary">{{ 'Request' | translate }}</button>
              </div>
            </div>
          }
        </form>
      </div>
    </div>
  }
